import { useLocation } from 'react-router-dom';

/**
 * Detects if user came from internal navigation or external link (shared URL).
 * Uses React Router location state to determine source.
 *
 * - If location.state.fromApp is truthy -> isDirectLink = false (internal navigation)
 * - Otherwise -> isDirectLink = true (direct link, shared URL, bookmark, etc.)
 */
export function useNavigationSource() {
  const location = useLocation();
  const isDirectLink = !location.state?.fromApp;

  return { isDirectLink };
}
